import { render, staticRenderFns } from "./AuthorizationMap.vue?vue&type=template&id=9a10a202&scoped=true&"
import script from "./AuthorizationMap.vue?vue&type=script&lang=js&"
export * from "./AuthorizationMap.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationMap.vue?vue&type=style&index=0&id=9a10a202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a10a202",
  null
  
)

export default component.exports